<template>
    <span class="badge badge-icon" :style="`background-color: ${resolved.badgeColor}; color: ${resolved.textColor}`">
        <i :class="`${resolved.iconPrefix} fa-${resolved.icon}`" :style="`background-color: ${resolved.iconColor}`" aria-hidden="true"></i>
        <span>{{$t(resolved.title)}}</span>
    </span>
</template>

<script>
import {badgeColors} from '../StatusBadge';
  export default {
    name: 'WorkflowBadge',
    props: {
      workflow: String,
    },
    computed: {
      resolved() {
        let {
          title = 'Unknown',
          icon = 'question-circle',
          iconPrefix = 'fa',
          textColor,
          iconColor,
          badgeColor,
          color,
        } = (this.$root.workflowTypes ?? {})[this.workflow] ?? {}

        if (!color && !iconColor && !badgeColor) {
          color = '#808080';
        }

        if (color && color.startsWith('#')) {
          let x = badgeColors(color);
          badgeColor = x.badgeColor;
          textColor = x.textColor;
          iconColor = x.iconColor;
        } else {
          textColor = iconColor;
          iconColor = badgeColor;
        }

        return {
          title,
          icon,
          iconPrefix,
          textColor,
          iconColor,
          badgeColor,
        }
      }
    }
  }
</script>

<style scoped>

</style>
